import { UserDisplay } from '@app/components/users';
import { socialExport } from '@mi-front/api-clients';
import { SocialPlatform } from '@app/modules/social-export/domain/platforms';
import { Alert, AlertTitle, Box } from '@mui/material';
import { useIntl } from 'react-intl';
import { FeatureManageFactory } from './platforms/FeatureManageFactory';
import { ProfileInfo } from './ProfileInfo';

interface Props {
  platform: SocialPlatform;
  stationId: string;
  state?: socialExport.GetConnectionStateDto;
}

export const FeatureState = ({ platform, stationId, state }: Props) => {
  const { $t } = useIntl();
  return state?.connected ? (
    <Box>
      <Alert severity="success">
        <AlertTitle>
          {$t({
            id: 'featureState.connected',
            defaultMessage: 'Integración conectada',
          })}
        </AlertTitle>

        {state.profile && <ProfileInfo profile={state.profile} />}

        <Box mt={1}>
          {$t({
            id: 'featureState.connectionConfiguredBy',
            defaultMessage: 'Conexión configurada por el usuario',
          })}{' '}
          <strong>
            <UserDisplay id={state.connectedBy!} />
          </strong>
        </Box>
      </Alert>
      <FeatureManageFactory platform={platform} stationId={stationId} />
    </Box>
  ) : (
    <Alert severity="warning">
      <AlertTitle>
        {$t({
          id: 'featureState.notConnected',
          defaultMessage: 'Integración no conectada',
        })}
      </AlertTitle>
    </Alert>
  );
};
